import {Menu, MenuItem, Typography} from '@mui/material';

export interface FishGroupOptionsMenuProps {
  open: boolean;
  options: string[];
  anchorEl: null | HTMLElement;
  handleCloseMenu: () => void;
  disableAutoFocus?: boolean;
}

export const FishGroupOptionsMenu = ({
  open,
  options,
  anchorEl,
  handleCloseMenu,
  disableAutoFocus,
}: FishGroupOptionsMenuProps): JSX.Element => (
  <Menu open={open} anchorEl={anchorEl} onClose={handleCloseMenu} disableAutoFocus={disableAutoFocus ?? false}>
    {options.map((option, index) => (
      <MenuItem key={index} sx={{pointerEvents: 'none'}}>
        <Typography variant="body2">{option}</Typography>
      </MenuItem>
    ))}
  </Menu>
);
